import vtkOrientationMarkerWidget from './OrientationMarkerWidget';
import vtkPiecewiseGaussianWidget from './PiecewiseGaussianWidget';

export default {
  vtkOrientationMarkerWidget,
  vtkPiecewiseGaussianWidget,
};
